"use strict";

exports.__esModule = true;
exports.default = void 0;

/**
 * @param {number} length
 * @return {Array}
 */
var _default = function _default(length) {
  return Array.apply(null, {
    length: length
  });
};

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/es/utils/range.js
// module id = 1262
// module chunks = 0